<template>
	<div>
		<a-modal v-show='!ishand' id='handweju' width='60rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top: '9vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="width: 58rem;">
					辦工用品
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="width: 58rem;" class='body_lis'>
				<div style="margin: 0 auto;width: 95%;">
					<div style="font-size: .8rem;text-align: right;padding: .5rem 0;color: #000000;">幣種：HKD</div>
					<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
						:rowKey='(record, index) => index'
						:pagination="false" 
						:bordered="true">
						<!-- :scroll="{ y: 560 }" -->
					<div slot='ax'  slot-scope="record">{{record.ax}}</div>
					<div slot="hot_status" slot-scope="record">
						<a-input v-model="record.stationery_name" class='warp_width' placeholder='' />
					</div>
					<div slot="a1" slot-scope="record">
						<a-input v-model="record.model" class='warp_width' placeholder='' />
					</div>
					<div slot="a2" slot-scope="record">
						<a-input v-model="record.amount" class='warp_width' placeholder='' @input='handitems(record.amount)'/>
					</div>
					<div slot="a3" slot-scope="record">
						<a-input v-model="record.unit" class='warp_width' placeholder='' />
					</div>
					<div slot="a4" slot-scope="record" style="position: relative;">
						<a-input v-model="record.unitprice" class='warp_width leftwarp' placeholder='' />
						 <div style="position: absolute;top: 5px;left: .5rem;font-size: 0.8rem">$</div>
					</div>
					<div slot="a5" slot-scope="record">
						<div style="text-align: left;margin-left: .5rem;">{{a5fn(record)}}</div>
					</div>
					<div slot="a6" slot-scope="record">
						<a-input v-model="record.remark" class='warp_width' placeholder='' />
					</div>
					</a-table>
					<div class='frombom'>
						<div style="width: 6%;float: left;font-size: .8rem;color: #000000;">合計</div>
						<div style="width: 18%;"> </div>
						<div style="width: 15%;text-align: left;padding-left: .8rem;font-size: .8rem;color: #000000;">{{allfn()}} </div>
						<!-- <div style="width: 13%;height:100%">&nbsp;</div> -->
					</div>
					<div style="text-align: center;padding-bottom: 1.2rem;padding-top: 1.2rem;">
						<button class='btn1 btnx' @click='resetForm("1")'>儲存</button>
						<button class='btn1 btn2' @click='resetForm("2")'>提交</button>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	export default {
		props: ['pared'],
		components: {
			rl
		},
		data() {
			return {
				visible: true,
				ishand: false,
				columnsData:[
					{	ax:1,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },
					{	ax:2,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:3,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:4,
					  "stationery_name":"",totalprice:'',
					  "model":"",
					  "amount":'',
					  "unit":"",
					  "unitprice":'',
					  "remark":""
					  },{	ax:5,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:6,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:7,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:8,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:9,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },{	ax:10,
					   "stationery_name":"",totalprice:'',
					   "model":"",
					   "amount":'',
					   "unit":"",
					   "unitprice":'',
					   "remark":""
					  },
					],
				columns: [{
						title: '序號',
						dataIndex: '',
						align: 'center',
						width: '6%',
						scopedSlots: {
							customRender: 'ax'
						}
					},
					{
					title: '文具名稱',
					dataIndex: '',
					align: 'center',
					width: '16%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'hot_status'
					}
					},
					{
					title: '規格型號',
					dataIndex: '',
					align: 'center',
					width: '15%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a1'
					}
					},
					{
					title: '數量',
					dataIndex: '',
					align: 'center',
					width: '10%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a2'
					}
					},{
					title: '單位',
					dataIndex: '',
					align: 'center',
					width: '7%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a3'
					}
					},{
					title: '單價',
					dataIndex: '',
					align: 'center',
					width: '13%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a4'
					}
					},{
					title: '總價',
					dataIndex: '',
					align: 'center',
					width: '15%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a5'
					}
					},{
					title: '備註',
					dataIndex: '',
					align: 'center',
					width: '18%',
					// slots: {
					// 	title: 'alltext'
					// },
					scopedSlots: {
						customRender: 'a6'
					}
					},
					],
				form: {
					"type": 4, //類型 1 假期申請 2 外出 3加班 4 文具
					"token":"",
					"issave":1,
					stationeryList:[]
				},
			}
		},
		watch:{
			columnsData:{
				deep:true,
				handler(){
					this.columnsData.map(ev=>{
						for(let key in ev){
							if(key == 'amount'||key == 'unitprice'){
								if(isNaN(ev[key])){
									ev[key] = ''
								}
							}
						}
					})
				}
			}
		},
		mounted() {
			this.handimg()
		},
		methods: {
			allfn(){
				let num = 0
				this.columnsData.map(ev=>{
					if(isNaN(ev.amount*ev.unitprice)){
						
					}else{
						num += ev.amount*ev.unitprice
					}
				})
				this.form.sumtotalprice = num.toFixed(2)
				return '$ ' + num.toFixed(2)
			},
			a5fn(record){
				if(isNaN(record.amount*record.unitprice)){
					record.totalprice = ''
					return '$'
				}else{
					record.totalprice = (record.amount*record.unitprice).toFixed(2)
					return '$ ' + (record.amount*record.unitprice).toFixed(2)
				}
			},
			handitems(val){
				
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.form = res.data
						if(res.data.stationeryList){
							for(let a = 0 ; a<res.data.stationeryList.length;a++){
							let b =  res.data.stationeryList[a]
							this.$set(this.columnsData,a,{
									ax:a+1,
								   "stationery_name":b.stationery_name,
								   "model":b.model,
								   "amount":b.amount,
								   "unit":b.unit,
								   "unitprice":b.unitprice,
								   "remark":b.remark,
							})
						}
						}
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(val) {
				let brr = []
				this.columnsData.map(ev=>{
					// model  型号 &&ev.model
					if(ev.stationery_name&&ev.amount&&ev.unit&&ev.unitprice){
						brr.push(ev)
					}
				})
				if(brr.length == 0){
					App.oTool.warningT('填写正确的数据');
					return
				}
				if(this.pared.applyid){
					this.form.applyid = this.pared.applyid
				}
				
				this.form.issave = val;
				this.form.type = 4;
				this.form.token = this.$store.state.token;
				this.form.stationeryList = brr
				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	.frombom{
		background-color: #f1f1f1;
		border-bottom: 1px solid #e8e8e8;
		border-left: 1px solid #e8e8e8;
		overflow: hidden;
		div{
			float: right;
			display: inline-block;
			text-align: center;
			padding: 9px 16px;
			border-right: 1px solid #e8e8e8;
		}
	}

	#handweju {
		
		.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
		    padding: 5px;
			font-size: .8rem;
			color: #000;
			}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-input {
			font-size: 0.8rem !important;
			border: 0;
			outline:none;
		}
		
		.leftwarp{
			padding-left: 1.2rem;
		}
		
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 4rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}
	}
</style>
